const messages = {
  toast: {
    logout: "Logout Successfully!",
    login: "Welcome Back!",
    nodata: "Data not found",
    alreadyLogin: `Sorry, you are currently \nsigned in to another device.`,
  },
  errors: {
    user_req: "Username is required!",
    pass_req: "Password is required!",
    product_name_err: "Name is required!",
    quantity_err: "Quantity is required!",
    reason_err: "Reason is required!",
    sample_lot_err: "Lot is required!",
    product_req: "Please select any one product",
    answer_req: "Please answer any one question",
    sample_req: "Please edit qty any one product",
    behavior_req: "MD Behavior is required!",
    product_behav_req: "Please select any one product and Write MD Behavior",
    sample_behav_req: "Please edit qty any one product and Write MD Behavior",
    answer_behav_req: "Please answer any one question and Write MD Behavior",
    join_call_req: "Who joined this call is required!",
    sign_req: "Please Draw signature first!",
    post_call_req: "Post Call Analysis is required!",
    next_call_req: "Next Call Objective is required!",
    md_select_req: "Please select MD!",
    md_name_req: "Firstname and Lastname is required!",
    image_req: "Please select screenshot is required!",
    sign_selfie_req: "Please do signature or Take selfie",
    promo_qty: "Given quantity cannot be greater than actual balance",
    img_type: "Only png image allowed!",
    sign_count:
      "13th signature not allowed anymore - perform matching first on any of the 12 signatures!",
    camera_permission:
      "If you've granted permission but we're still unable to find your camera!",
    camera_not_support: "Browser is not supporting camera!",
    microphone_permission:
      "If you've granted permission but we're still unable to find your microphone!",
    microphone_not_support: "Browser is not supporting microphone!",
    location_not_support: "Browser is not supporting geolocation!",
    location_denied:
      "The user has denied location permission. Please grant permission!",
    location_permission_issue:
      "If you've granted permission but we're still unable to find your location!",
    location_position_issue:
      "We're having trouble finding your location. Double-check your device settings and give it another try!",
    location_timeout_issue:
      "Taking a bit too long to find your location. Let's give it another shot!",
    location_unknown_issue:
      "Oops! Something went wrong while fetching your location. Please try again in a moment!",
    capture_selfie:
      "Something went wrong while capture image!, Please try again in a moment!",
    vmcMDSelection:
      "All MDs have already been assigned for the selected date, and their requests have been added. Please select a different date to submit a new request!",
    chooseImg: "Oops! We couldn’t choose the photo. Please try again!",
    captureImg: "Oops! We couldn’t capture the photo. Please retake the photo!",
  },
  apiMessage: {
    cycle: "Checking Active Cycle!",
    notificationCount: "Getting new notifications!",
    notification: "Getting new notifications!",
    mdBirthday: "Making sure you don't miss MD birthdays!",
    itinerary: "Preparing your work load - Itineraries!",
    cumulativeReport: "Generating Cumulative reports!",
    reports: "Generating some more reports of your good work!",
    quickSign: "Quickly syncing QuickSigns!",
    masterMDList: "Updating Master MDs!",
    nextMItinerary: "Getting Next Month's Itinerary!",
    mdInfoDetails: "Getting MD Info Requests!",
    mdInfoRequest: "Getting MD Info Requests!",
    vmcList: "Getting updated VMC list!",
    vmcModalData: "Getting updated VMC list!",
    timeInOut: "Making sure TimeIn/Out is reported!",
    balanceMaterials: "Getting balance Promo Materials!",
    issuedMaterials: "Getting issued Promo Materials!",
    promoReasons: "Getting promo Material details!",
    groupCallActivities: "Getting Group Call Activities!",
    cmGroupCall: "Getting Current Month Group Call!",
    nmGroupCall: "Getting Next Month Group Call!",
    getGroupCallReport: "Getting Group Call Report!",
    getMDProfileData: "Getting MD Profile Data!",
  },
};

const toastMessages = {
  logout: "Logout Successfully!",
  login: "Welcome Back!",
  noMD: "No MD to display",
  noLocation: "No Location Found",
  notYetAvailable: "Not yet available",
  alreadyLogin: `Sorry, you are currently \nsigned in to another device.`,
  offlineMode: `Offline mode is ready!, \nYou can now use this app even without an internet connection.`,
};

const errorMessage = {
  notes_req: "Notes is required!",
  attachment_req: "Attachment is required!",
  user_req: "Username is required!",
  pass_req: "Password is required!",
  product_req1: "Please select product!",
  adoption_req: "Please select adoption stage!",
  product_name_err: "Name is required!",
  quantity_err: "Quantity is required!",
  reason_err: "Reason is required!",
  sample_lot_err: "Lot is required!",
  product_req: "Please select any one product",
  day_req: "Please select day!",
  time_req: "Please select time!",
  answer_req: "Please answer any one question",
  sample_req: "Please edit qty any one product",
  behavior_req: "MD Behavior is required!",
  product_behav_req: "Please select any one product and Write MD Behavior",
  sample_behav_req: "Please edit qty any one product and Write MD Behavior",
  answer_behav_req: "Please answer any one question and Write MD Behavior",
  join_call_req: "Who joined this call is required!",
  sign_req: "Please Draw signature first!",
  post_call_req: "Post Call Analysis is required!",
  next_call_req: "Next Call Objective is required!",
  md_select_req: "Please select MD!",
  md_name_req: "Firstname and Lastname is required!",
  image_req: "Please select screenshot is required!",
  sign_selfie_req: "Please do signature or Take selfie",
  promo_qty: "Given quantity cannot be greater than actual balance",
  img_type: "Only png image allowed!",
  sign_count:
    "13th signature not allowed anymore - perform matching first on any of the 12 signatures!",
  vmcMDSelection:
    "All MDs have already been assigned for the selected date, and their requests have been added. Please select a different date to submit a new request!",
  capture_selfie:
    "Something went wrong while capture image!, Please try again in a moment!",
  chooseImg: "Oops! We couldn’t choose the photo. Please try again!",
  captureImg: "Oops! We couldn’t capture the photo. Please retake the photo!",
  vmcAllDayMDSelection: "Please select at-least 14 MDs before submit request!",
  plotLimit: "Please plot 20 MDs per day.",
  firstApproveRequest:
    "There are still pending requests for this date. You can start plotting once they’re approved by DM.",
  dayHoliday:
    "This day is a holiday. Please select another date to schedule your call.",
  dayWeekend:
    "Weekend date selected. Please select another date to schedule your call.",
  itineraryDayLimit:
    "You have reached the daily limit of 20 MDs.\nPlease select another date.",
  sandwichRule:
    "This is Sandwich Rule. You are not allowed to plot the same MD on consecutive dates.",
  validSignature:
    "Please note that calls cannot be scheduled or recorded on two consecutive days.",
  callAlreadyExist: "This MD call already exists for today!",
  onlyOneCallAllowed: "Only one call is allowed per day!",
  mdAlreadyExist: "MD Already Exist!",
  mdAlreadyForApproval: "MD Already Added For Approval!",

  // Browser Service
  camera_permission:
    "If you've granted permission but we're still unable to find your camera!",
  camera_not_support: "Browser is not supporting camera!",
  microphone_permission:
    "If you've granted permission but we're still unable to find your microphone!",
  microphone_not_support: "Browser is not supporting microphone!",
  location_not_support: "Browser is not supporting geolocation!",
  location_denied:
    "The user has denied location permission. Please grant permission!",
  location_permission_issue:
    "If you've granted permission but we're still unable to find your location!",
  location_position_issue:
    "We're having trouble finding your location. Double-check your device settings and give it another try!",
  location_timeout_issue:
    "Taking a bit too long to find your location. Let's give it another shot!",
  location_unknown_issue:
    "Oops! Something went wrong while fetching your location. Please try again in a moment!",
  syncFailed: "Failed to sync data!",
  syncData: "Please resync the data!",
  userBlock: "You are blocked!",
  syncToAvoidAnyLoss: "Please sync your data to avoid any loss!",
  assistanceDM:
    "Device time manipulation was detected. For security reasons, your access has been blocked. Contact DM for assistance.",
};

const dataMessages = {
  nodata: "Data not found",
  noRestaurant: "No restaurant to display",
  noItems: "No items to display",
  noReports: "No report to display",
  noitinerary: "No itinerary to display",
  skippedSiphoning: "Siphoning skipped!",
};

export { messages, toastMessages, errorMessage, dataMessages };
